import { Eye, EyeOff } from 'lucide-react'
import { FC } from 'react'

import { cn } from '../../utils/cn'
import { Button } from '../button'
import { SimpleTooltip } from '../tooltip/simple-tooltip'

interface TogglePasswordButtonProps {
  isVisible: boolean
  onToggle: () => void
  className?: string
}

export const TogglePasswordButton: FC<TogglePasswordButtonProps> = ({
  isVisible,
  onToggle,
  className
}) => {
  const Icon = isVisible ? Eye : EyeOff
  const label = isVisible ? 'Hide password' : 'Show password'
  return (
    <SimpleTooltip content={label}>
      <Button
        type="button"
        buttonType="transparent"
        buttonShape="square"
        buttonSize="sm"
        onClick={onToggle}
        className={cn('absolute right-1 top-1/2 -translate-y-1/2', className)}
        aria-label={label}
        leftIconSlot={<Icon aria-hidden />}
      />
    </SimpleTooltip>
  )
}
